import { render, staticRenderFns } from "./StartRecording.vue?vue&type=template&id=e0547d18&scoped=true"
import script from "./StartRecording.vue?vue&type=script&lang=js"
export * from "./StartRecording.vue?vue&type=script&lang=js"
import style0 from "./StartRecording.vue?vue&type=style&index=0&id=e0547d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0547d18",
  null
  
)

export default component.exports